var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c(
        "div",
        { staticClass: "nk-block-between align-items-start" },
        [
          _c("div", { staticClass: "nk-block-head-content" }, [
            _c("h3", { staticClass: "nk-block-title page-title" }, [
              _vm._v(_vm._s(_vm.trans("locale.edit_locale"))),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
              attrs: { to: "/configuration/locale" },
            },
            [_vm._v(_vm._s(_vm.trans("general.back")))]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "locale" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c("div", { staticClass: "admin-config-panel__inner" }, [
            _c(
              "section",
              {
                staticClass: "admin-config-section",
                attrs: { "aria-label": _vm.trans("locale.edit_locale") },
              },
              [_c("locale-form", { attrs: { id: _vm.id } })],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [
        _vm._v(
          "Update the locale display name and code used throughout language selection."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }